/* global loadRecaptchaWithoutDefence, resetRecaptcha */

import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Container from "../../../common/Container";
import H from "../../../common/Typography/H";
import Examples from "./Examples";
import Button from "../../../common/Button";
import Modal from "../../../common/Modal";
import ServiceForm from "../ServiceForm";
import reachZayavkaGoal from "../../../common/reach-zayavka-goal";
import handleSampleOrderResponse, {
  handleSampleOrderError
} from "./handle-sample-order-response";
import {authenticityTokenSelector} from "../../ducks/authenticity-token";
import {siteKeySelector} from "../../ducks/site-key";
import {
  serviceModalSelector,
  openServiceModal as openServiceModalAC,
  closeServiceModal as closeServiceModalAC
} from "../../ducks/service-modal";

import styles from "./clients.module.scss";

function Clients(props) {
  const {
    authenticityToken,
    siteKey,
    serviceModal: {isOpen: isModalOpen},
    openServiceModal,
    closeServiceModal
  } = props;
  const serviceFormRef = useRef(null);

  useEffect(() => {
    if (isModalOpen) {
      loadRecaptchaWithoutDefence();
    }
  }, [isModalOpen]);

  const closeModal = () => {
    closeServiceModal();
  };
  const openModal = () => {
    openServiceModal();
  };
  const handleForm = (data) => {
    const formData = new FormData();
    formData.append(`authenticity_token`, authenticityToken);
    const recaptchaResponseInput = serviceFormRef.current.querySelector(
      `.g-recaptcha-response`
    );
    formData.append(
      `g-recaptcha-response`,
      recaptchaResponseInput ? recaptchaResponseInput.value : ``
    );
    Object.keys(data).forEach((name) => {
      const value = data[name];
      if (typeof value === `object`) {
        Array.from(value).forEach((file) => {
          formData.append(`sample_order_request[${name}]`, file);
        });
      } else {
        formData.append(`sample_order_request[${name}]`, value);
      }
    });
    return fetch(`/sample_order_requests`, {
      method: `POST`,
      credentials: `same-origin`,
      body: formData
    })
      .then(handleSampleOrderResponse)
      .then((response) => {
        reachZayavkaGoal();
        return response;
      })
      .catch(handleSampleOrderError)
      .finally(() => resetRecaptcha(serviceFormRef.current));
  };
  return (
    <div className={styles.root}>
      <Container>
        <H level={2} className={styles.title}>
          Корпоративным клиентам
        </H>
        <div className={styles.advantages}>
          <div className={styles.advantagesItem}>
            Шьём свою одежду и отбираем только самых лучших поставщиков
          </div>
          <div className={styles.advantagesItem}>
            Делаем быстро и в срок: прямая печать — от 2 часов, шелкография — от
            1 дня
          </div>
          <div className={styles.advantagesItem}>
            Мы всегда на связи, без выходных и праздников, днём и ночью
          </div>
        </div>
      </Container>
      <div className={styles.examples}>
        <Examples />
      </div>
      <Container className={styles.footer}>
        <Button
          variant="contained"
          size="large"
          style="primary"
          className={styles.button}
          onClick={openModal}
        >
          Напишите нам
        </Button>
        <div>
          Или позвоните: <a href="tel:+7 495 118-05-68">+7 495 118-05-68</a>
        </div>
        <Modal isOpen={isModalOpen} onRequestClose={closeModal}>
          <div ref={serviceFormRef}>
            <ServiceForm
              authenticityToken={authenticityToken}
              siteKey={siteKey}
              onSubmit={handleForm}
              onRequestClose={closeModal}
            />
          </div>
        </Modal>
      </Container>
    </div>
  );
}

Clients.propTypes = {
  authenticityToken: PropTypes.string,
  siteKey: PropTypes.string,
  serviceModal: PropTypes.object,
  openServiceModal: PropTypes.func,
  closeServiceModal: PropTypes.func
};

export default connect(
  (state) => ({
    authenticityToken: authenticityTokenSelector(state),
    siteKey: siteKeySelector(state),
    serviceModal: serviceModalSelector(state)
  }),
  {
    openServiceModal: openServiceModalAC,
    closeServiceModal: closeServiceModalAC
  }
)(Clients);
